import React from "react";
import PageTop from "../ui/page-top";

const NotFound = () => {
  return (
    <React.Fragment>
       <PageTop
              is_logged={false}
              page={{ title: "Page Not Found", url: "/", bg_color: "sky" }}
            />
            <div className="page-body">
                <div className="pane-container py30">
                  <div className="half-pane white px20 py20">
                   
                   <h1>Page Not Found</h1>
                   <p>
                    The page you are looking for does not exist. It might have been removed, had its name changed, or is temporarily unavailable. Please check the URL for errors and try again. If you believe this is an error, please contact our support team for assistance.
                   </p>
                  </div>
                </div>
            </div>
    </React.Fragment>
  );
};

export default NotFound;
